var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { unmountComponentAtNode } from 'react-dom';
import { property } from 'lit-element';
import { createEmbedEmotionCache } from '@embed/createEmbedEmotionCache';
import storyblockRender from '@embed/storyblockRender';
import fwnInit from '@src/embeds/utils/fwnInit';
import { WidgetTypesEnum } from '../embed/widgetTypes';
import { FWNElement } from './bases/FWNElement';
fwnInit(window);
class StoryblockElement extends FWNElement {
    constructor() {
        super(...arguments);
        this.height = '75vh';
        this.__version = process.env.RELEASE_VERSION;
    }
    render() {
        const attrs = Object.fromEntries(this.getAttributeNames().map((name) => [name, this.getAttribute(name)]));
        this.style.width = '100%';
        if (this.shadowRoot) {
            unmountComponentAtNode(this.shadowRoot);
            storyblockRender(Object.assign(Object.assign({ type: WidgetTypesEnum.STORYBLOCK, height: this.height }, attrs), { target: this.shadowRoot }), createEmbedEmotionCache({
                container: this.shadowRoot,
            }));
        }
    }
}
__decorate([
    property({ type: String })
], StoryblockElement.prototype, "height", void 0);
if (!customElements.get('fw-storyblock')) {
    customElements.define('fw-storyblock', StoryblockElement);
}
